import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { SupplierAdd } from '#app/routes/mocra+/_form+/components/suppliers/add.tsx'
import { SupplierCard } from '#app/routes/mocra+/_form+/components/suppliers/card.tsx'
import { type SupplierDraft } from '#app/routes/mocra+/_form+/components/suppliers/types.ts'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type SupplierListItem = {
	readonly draft: SupplierDraft
	readonly errors: readonly string[]
}

type Props = {
	readonly resources: SectionResources
	readonly suppliers: ReadonlyArray<SupplierListItem>
	readonly onAdd: (draft: SupplierDraft) => void
	readonly onEdit: (index: number) => void
	readonly onRemove: (index: number) => void
	readonly emptyState?: string
}

export function CriticalSuppliersSection({
	resources,
	suppliers,
	onAdd,
	onEdit,
	onRemove,
	emptyState = 'No critical suppliers documented yet.',
}: Props) {
	return (
		<Section
			title="Critical suppliers"
			description="List the ingredient, packaging, and service partners that impact product safety. Mark risk level and whether a quality agreement is in place."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
		>
			<div className="space-y-3">
				{suppliers.length > 0 ? (
					suppliers.map((supplier, index) => {
						const errors = supplier.errors
						return (
							<SupplierCard
								key={`supplier-${index}`}
								index={index}
								supplier={supplier.draft}
								onEdit={() => onEdit(index)}
								onRemove={() => onRemove(index)}
								errors={errors.length > 0 ? [...errors] : undefined}
							/>
						)
					})
				) : (
					<p className="text-muted-foreground text-sm">{emptyState}</p>
				)}
			</div>
			<SupplierAdd onSubmit={onAdd} />
		</Section>
	)
}
